export default function getEmailRecoveryStage(queryParameters, recoveredAt) {
  if (
    recoveredAt == null ||
    (!queryParameters && !queryParameters?.utm_source && !queryParameters?.utm_campaign)
  )
    return null;

  const isEmailRecovery =
    queryParameters.utm_source === 'email' && queryParameters.utm_campaign === 'cart_abandonment';

  if (!isEmailRecovery) return null;

  const emailStageMap = {
    email_first: '1st',
    email_second: '2nd',
    email_third: '3rd',
  };

  const stage = emailStageMap[queryParameters?.utm_content];

  return stage ? `${stage} reminder email` : 'Reminder email';
}
